// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import { FaInfinity } from 'react-icons/fa';

const MILE_STEPS = [
  '10 Miles', '20 Miles', '30 Miles', '40 Miles', '50 Miles', '60 Miles', '100 Miles', '200 Miles', '250 Miles', '300 Miles', '500 Miles', 'Unlimited Miles',
];

const InputRange = ({ handler, defaultValue = NaN, className = '' }) => {
  const [value, setValue] = useState(4);
  const isSubpage = className.includes('subpage-contractors-range');

  useEffect(() => {
    const buf = !defaultValue ? 10 : MILE_STEPS.indexOf(`${defaultValue} Miles`);
    if (buf !== -1 && buf !== value) setValue(buf);
  }, [defaultValue]);

  const labelContent = MILE_STEPS[value] === 'Unlimited Miles'
    ? <FaInfinity aria-hidden style={isSubpage ? undefined : { fontSize: '2.5rem' }} />
    : MILE_STEPS[value];

  const emitValue = (index) => {
    handler(parseInt(MILE_STEPS[index], 10));
  };

  if (isSubpage) {
    return (
      <div className={`subpage-contractors-range__control ${className}`.trim()}>
        <label htmlFor="customRange1" className="subpage-contractors-range__label">
          {labelContent}
        </label>
        <input
          type="range"
          className="subpage-contractors-range__input"
          id="customRange1"
          max={11}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onMouseUp={(e) => emitValue(e.target.value)}
          onTouchEnd={(e) => emitValue(e.target.value)}
        />
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <label
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        htmlFor="customRange1"
        className="range_label"
      >
        {labelContent}
      </label>
      <input
        type="range"
        className="custom-range"
        id="customRange1"
        max={11}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onMouseUp={(e) => emitValue(e.target.value)}
        onTouchEnd={(e) => emitValue(e.target.value)}
      />
    </div>
  );
};

export default InputRange;
